//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getProvince, getCity, getCounty } from '@/api/sys.js'
import { isWorker, getShowList, getShowCount, getShowDetail, getCountyShowCount } from '@/api/zhigongxiaojia'
import amp from './map.vue' // 引入地图子组件
import markerIcon from '@/assets/zhigongxiaojia/marker (2).png'
import { operateCreditlist } from '@/api/user'
import { getaddlog } from '@/api/hgfw'
export default {
  name: 'home',
  components: { amp },
  data () {
    return {
      tabs: [{
        name: '杭州',
        value: '1',
        local: [120.19, 30.26]
      }, {
        name: '宁波',
        value: '2',
        local: [121.56, 29.86]
      }, {
        name: '温州',
        value: '3',
        local: [120.65, 28.01]
      }, {
        name: '嘉兴',
        value: '5',
        local: [120.76, 30.77]
      }, {
        name: '湖州',
        value: '4',
        local: [120.1, 30.86]
      }, {
        name: '绍兴',
        value: '6',
        local: [120.58, 30.01]
      }, {
        name: '金华',
        value: '7',
        local: [119.64, 29.12]
      }, {
        name: '衢州',
        value: '8',
        local: [118.88, 28.97]
      }, {
        name: '丽水',
        value: '11',
        local: [119.92, 28.45]
      }, {
        name: '台州',
        value: '10',
        local: [121.42, 28.60]
      }, {
        name: '舟山',
        value: '9',
        local: [122.10, 30.01]
      }, {
        name: '直属',
        value: '',
        local: [120, 29]
      }],
      list: [],
      temp: 0,
      isWorker: 0,
      sourcetype: 1, // 1|职工小家
      markers: [],
      count: '', // 全省职工小家数
      citycount: '', // 市职工小家数
      provinceid: '',
      mapCenter: [],
      curCityid: '1',
      curCityName: '杭州',
      countyid: '',
      areatype: '',
      countyList: [],
      zoom: 7,
      point: [120, 30]
    }
  },
  watch: {
    $route (to, from) {
      // console.log('to', to.path)
      // console.log('from', from.path)
      if (from.path !== '/zhigongxiaojia/detail' && to.path !== '/zhigongxiaojia/detail' && to.path !== '/zhigongxiaojia/workspace/declare') {
        // console.log('test')
        // this.reload()
        location.reload()
      }
    }
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    },
    userid () {
      return this.$store.state.user.userid
    },
    auth () {
      return this.$store.state.user.workerObj.auth || ''
    }
  },
  mounted () {
    this.getIsWorker()
    this.getprovinceCountNow()
    this.addCredit()
    this.getAdd()
  },
  methods: {
    addCredit () {
      /* 添加积分 */
      if (this.accountid !== '' && this.accountid != null) {
        operateCreditlist({
          accountid: this.accountid,
          rulecode: 'zgxj_rule',
          credit: 1,
          owner_type: '2007',
          terminaltype: 2
        }).then(res => { })
      }
    },
    getAdd () {
      getaddlog({
        accountid: this.accountid,
        moduleid: 1200,
        submoduleid: 120121
      }).then(res => {
      })
    },
    gotoWork () {
      // 根据权限跳转页面
      if (this.auth.indexOf('2') > -1) {
        this.$router.push({ name: 'zhigongxiaojiaWorkspaceDeclare' })
      } else if (this.auth.indexOf('3') > -1) {
        this.$router.push({ name: 'zhigongxiaojiaWorkspaceDealList' })
      } else if (this.auth.indexOf('1') > -1) {
        this.$router.push({ name: 'zhigongxiaojiaWorkspaceUserList' })
      }
    },
    // 判断是否为工作人员
    getIsWorker () {
      isWorker({
        accountid: this.accountid,
        sourcetype: this.sourcetype
      }).then(data => {
        this.isWorker = data.returnValue.isWorker // 1工作人员
        this.provinceid = data.returnValue.provinceid
        this.$store.commit('setWorkerObj', data.returnValue)
      })
    },
    // 职工小家列表
    getList (data, point) {
      this.mapCenter = data
      this.point = point
      console.log(data.length)
      getShowList({
        areatype: this.areatype == 1 || this.areatype == 4 ? this.areatype : '',
        provinceid: this.provinceid,
        cityid: this.curCityid,
        countyid: this.areatype == 1 || this.areatype == 4 ? '' : this.countyid,
        sourcetype: this.sourcetype,
        dealstatus: 1,
        page: 1,
        rows: 100
      }).then(res => {
        this.markers = []
        res.returnValue.list.forEach((item, index) => {
          let marker = this.amap(item.longitude, item.latitude)
          item.distance = this.distance(data, marker)
          let objj = {
            id: item.id,
            name: item.unitname,
            content: `<div style="z-index:9999"><img src="${markerIcon}" width="15"></div>`,
            marke: marker
          }
          this.markers.push(objj)
          //   console.log(this.markers)
        })
        this.list = res.returnValue.list
        this.list.sort(this.compare('distance'))
      })
    },
    // 职工小家总数
    getprovinceCountNow () {
      getShowCount({
        sourcetype: this.sourcetype,
        provinceid: 31,
        dealstatus: 2
      }).then(data => {
        this.count = data.returnValue.count
      })
      getShowCount({
        sourcetype: this.sourcetype,
        provinceid: 31,
        cityid: this.curCityid,
        dealstatus: 2
      }).then(data => {
        this.citycount = data.returnValue.count
      })
      // 获取区县数据
      getCountyShowCount({
        sourcetype: this.sourcetype,
        cityid: this.curCityid
      }).then(res => {
        this.countyList = res.returnValue.countyList
      })
    },
    // 获取省内的地市列表
    // getCityNow () {
    //   getCity({
    //     plistvalue: this.provinceid
    //   }).then(data => {
    //     data.obj.forEach(element => {
    //       if (element.key != '') {
    //         this.tabs.push({
    //           name: element.value,
    //           value: element.key
    //         })
    //       }
    //     })
    //   })
    // },
    // 跳转页面
    Todetail (item) {
      this.$router.push({ path: '/zhigongxiaojia/detail', query: { id: item.id } })
    },
    // 实现城市切换
    tab (index, obj) {
      this.temp = index
      this.curCityid = obj.value
      this.curCityName = obj.name
      this.countyid = ''
      if (obj.value !== '') {
        this.areatype = ''
        this.getList(this.mapCenter, obj.local)
        // 获取区县数据
        getCountyShowCount({
          sourcetype: this.sourcetype,
          cityid: this.curCityid
        }).then(res => {
          this.countyList = res.returnValue.countyList
        })
      } else if (obj.value === '') {
        this.countyList = []
        this.areatype = '1'
        this.zoom = 6
        this.getList(this.mapCenter, obj.local)
      }
      // 获取当前城市的小家总数
      getShowCount({
        sourcetype: this.sourcetype,
        provinceid: 31,
        cityid: this.curCityid,
        dealstatus: 2,
        areatype: this.areatype
      }).then(data => {
        this.citycount = data.returnValue.count
      })
    },
    showCountyData (item) {
      this.areatype = item.areatype
      this.countyid = item.id
      // TODO 还差区级对应的经纬度赋值 如果不变 就取市中心的经纬度
      this.getList(this.mapCenter)
    },
    distance (p1, p2) {
      // 返回 p1 到 p2 间的地面距离，单位：米
      let dis = AMap.GeometryUtil.distance(p1, p2)
      return (dis / 1000).toFixed(2)
    },
    amap (bd_lng, bd_lat) {
      var X_PI = (Math.PI * 3000.0) / 180.0
      var x = bd_lng - 0.0065
      var y = bd_lat - 0.006
      var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI)
      var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI)
      var gg_lng = z * Math.cos(theta)
      var gg_lat = z * Math.sin(theta)
      return [gg_lng, gg_lat]
    },
    // 排序
    compare (property) {
      return (a, b) => {
        let v1 = parseFloat(a[property])
        let v2 = parseFloat(b[property])
        return v1 - v2
      }
    }
  }
}
